export default "__VITE_ASSET__Ceijd$pG__"